import PropTypes from "prop-types"
import DelayIcon from "../icons/delay_icon"
import FilterIcon from "../icons/filter_icon"

const StepDetails = ({
  brandColor,
  image,
  name,
  serviceName,
  label,
  finalStep,
}) => {
  const isFilter = label === "When"
  const isDelay = label === "Wait"
  const isQuery = label === "With"
  const largeImage = label === "If" || label === "Then"

  const serviceImage = () => {
    if (isFilter) {
      return <FilterIcon />
    } else if (isDelay) {
      return <DelayIcon />
    } else {
      return <img src={image} alt={`${serviceName} icon`} />
    }
  }

  return (
    <>
      <div className={finalStep ? "step final" : "step"}>
        <div className="details-row">
          <h3 className="label">{label}</h3>
          <div className="icon">
            <div
              className={largeImage ? "large" : "small"}
              style={{ backgroundColor: brandColor }}
            >
              {serviceImage()}
            </div>
          </div>
          <div className="details">
            <h5 className="service-name">{serviceName}</h5>
            {isFilter || isDelay || isQuery ? (
              <></>
            ) : (
              <p className="txt-caption">{name}</p>
            )}
          </div>
        </div>
      </div>
      {finalStep ? null : (
        <div className="guideline-container">
          <div className="label" />
          <div className="guideline" />
        </div>
      )}
    </>
  )
}

StepDetails.propTypes = {
  brandColor: PropTypes.string,
  image: PropTypes.string,
  name: PropTypes.string,
  serviceName: PropTypes.string,
  label: PropTypes.string,
  finalStep: PropTypes.bool,
}

export default StepDetails
